<script setup>
import { ref, onBeforeMount, onUnmounted, computed } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

import AgentLayout from "@/views/layouts/AgentLayout.vue";
import DBreadcrumb from "@/components/shared/DBreadcrumb.vue";
import PageHeader from "@/components/shared/PageHeader.vue";
import moment from "moment-timezone";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useConfigsStore } from "@/stores/configs";
const company_id = useCompanyStore().companyId;

const uiStore = useUiStore();
const configsStore = useConfigsStore();
const route = useRoute();
let id = ref(null);
let name = ref(null);
let description = ref(null);
let device_name = ref(null);
let time_zone = ref(null);
let timeZoneNames = ref([]);
let system_fan = ref(true);
let show_status_bar = ref(false);
let schedule_reboot = ref(false);
let gps = ref(false);
let bluetooth = ref(false);
let mobile_data = ref(false);
let schedule_reboot_time = ref({
  hours: 0,
  minutes: 0,
});
let brightness = ref(null);
let volume = ref(null);
let settingsArr = ref([]);
let preinstalledApps = ref([]);
let appsOptions = ref([]);
let preinstalledAppsOptions = ref([]);
let appMode = ref({
  type: "",
  apps: "",
  timeMillisecond: 0,
  broadcastEnable: 1,
});
let networkGuard = ref({
  enable: 1,
  type: 0,
  time: 15,
  ipInternet: null,
  ipIntranet: null,
  logPath: "directory/NetworkProtectLog",
  reboot: 1,
});

// let daemonApp = ref({
//   packageName: '' ,

// });

let appModeTypeOptions = ref(["Single", "None"]);
let isLoadingApps = ref(true);
let isLoadingPreinstalledApps = ref(true);
let isDisableAppType = ref(false);

let isLoading = ref(true);
const activeTab = ref('general');
let isSubmitted = ref(false);
let applicattionModaSelection = ref(true);

let autoBrightnessFields = ref([]);
let autoOnOffFields = ref([]);

let networkGuardTypeOptions = ref([
  { id: 0, name: "Automatic" },
  { id: 1, name: "Ethernet" },
  { id: 2, name: "WIFI" },
  { id: 3, name: "Mobile network" },
]);

let networkGuardType = ref(null);
// let daemonAppPackageName = ref(null);
let isInvalidNetworkGuardTime = ref(false);

// let ipInternet = ref([]);
const addAutoBrightnessField = () => {
  let currentDateTime = moment(new Date()).format("HH:mm");
  currentDateTime = currentDateTime.split(":");

  let currentDateTimeObj = ref({
    hours: currentDateTime[0],
    minutes: currentDateTime[1],
  });
  autoBrightnessFields.value.push({
    start: currentDateTimeObj,
    end: currentDateTimeObj,
    value: 50,
    from: "",
    to: "",
  });
};

const changeTypeVal = () => {

  isDisableAppType.value = false;
  applicattionModaSelection.value = false;
  appMode.value.apps = "";
  appMode.value.timeMillisecond = 0;
  appMode.value.broadcastEnable = 0;

  if (appMode.value.type == "Single") {
    applicattionModaSelection.value = false;
  } else if (appMode.value.type == "Multiple") {
    applicattionModaSelection.value = true;
  } else if (appMode.value.type == "None") {
    isDisableAppType.value = true;
  }
};

const removeAutoBrightnessField = (index) => {
  autoBrightnessFields.value.splice(index, 1);
};

const addAutoOnOffField = () => {
  let currentDateTime = moment(new Date()).format("HH:mm");
  currentDateTime = currentDateTime.split(":");

  let currentDateTimeStartObj = ref({
    hours: currentDateTime[0],
    minutes: currentDateTime[1],
  });
  let currentDateTimeEndObj = ref({
    hours: currentDateTime[0],
    minutes: currentDateTime[1],
  });

  autoOnOffFields.value.push({
    start: currentDateTimeStartObj,
    end: currentDateTimeEndObj,
    value: "off",
    from: "",
    to: "",
  });
};

const formatingTimeObject = async (array) => {
  if (array.length) {
    await array.map(async (obj) => {
      let fromTime = obj.from.split(":");
      let toTime = obj.to.split(":");

      obj.start = await { hours: fromTime[0], minutes: fromTime[1] };
      obj.end = await { hours: toTime[0], minutes: toTime[1] };

      if (obj.value == "on" || obj.value == "off") {
        if (obj.value == "on") obj.value = true;
        else obj.value = false;
      }
    });

    return array;
  }
};

const reformatingTimeObjectBeforeSubmit = async (array) => {
  if (array.length) {
    await array.map(async (obj) => {
      obj.from = await moment(obj.start).format("HH:mm");
      obj.to = await moment(obj.end).format("HH:mm");

      if (obj.value === true || obj.value === false) {
        if (obj.value) obj.value = "on";
        else obj.value = "off";
      }
    });

    return array;
  }
};

const changeNetworkGuardTime = () => {
  isInvalidNetworkGuardTime.value = false;
  if (networkGuard.value.time < 3 || networkGuard.value.time > 15)
    isInvalidNetworkGuardTime.value = true;
};


const onSubmit = async () => {
  isSubmitted.value = true;
  let scheduleRebootTimeString = await moment(
    schedule_reboot_time.value,
  ).format("HH:mm");
  let autoBrightnessVal = await reformatingTimeObjectBeforeSubmit(
    autoBrightnessFields.value,
  );
  let autoOnOffVal = await reformatingTimeObjectBeforeSubmit(
    autoOnOffFields.value,
  );

  let preinstalledAppsArr = [];

  preinstalledApps.value.map((app) => {
    let appObj = {};
    appObj.id = app.id;
    appObj.name = app.name;
    appObj.package_name = app.metadata?.package_name;
    appObj.application_label = app.metadata?.application_label;
    appObj.application_version_code = app.metadata?.application_version_code;
    appObj.application_version_name = app.metadata?.application_version_name;
    appObj.url = app.url;
    preinstalledAppsArr.push(appObj);
  });


  settingsArr.value.map((obj) => {
    if (obj.name == "device_name") {
      obj.value = device_name.value;
    } else if (obj.name == "system_fan") {
      obj.value = system_fan.value ? 1 : 0;
    } else if (obj.name == "schedule_reboot") {
      obj.value = schedule_reboot.value ? 1 : 0;
    } else if (obj.name == "show_status_bar") {
      obj.value = show_status_bar.value ? 1 : 0;
    } else if (obj.name == "gps") {
      obj.value = gps.value ? 1 : 0;
    } else if (obj.name == "bluetooth") {
      obj.value = bluetooth.value ? 1 : 0;
    } else if (obj.name == "mobile_data") {
      obj.value = mobile_data.value ? 1 : 0;
    } else if (obj.name == "schedule_reboot_time") {
      obj.value = scheduleRebootTimeString;
    } else if (obj.name == "brightness") {
      obj.value = brightness.value;
    } else if (obj.name == "volume") {
      obj.value = volume.value;
    } else if (obj.name == "time_zone") {
      obj.value = time_zone.value;
    } else if (obj.name == "auto_brightness") {
      obj.value = autoBrightnessFields.value.length
        ? JSON.stringify(autoBrightnessVal)
        : JSON.stringify([]);
    } else if (obj.name == "auto_on_off") {
      obj.value = autoOnOffFields.value.length
        ? JSON.stringify(autoOnOffVal)
        : JSON.stringify([]);
    } else if (obj.name == "app_mode") {
      appMode.value.broadcastEnable = appMode.value.broadcastEnable ? 1 : 0;
      appMode.value.timeMillisecond = appMode.value.timeMillisecond
        ? appMode.value.timeMillisecond * 1000
        : 0;
      if (appMode.value.type == "Single") {
        appMode.value.apps = [appMode.value.apps];
      } else if (appMode.value.type == "None") {
        appMode.value.apps = [];
      }
      obj.value = JSON.stringify(appMode.value);
    } else if (obj.name == "pre_installed_apps") {
      obj.value = JSON.stringify(preinstalledAppsArr);
    } else if (obj.name == "network_guard") {
      networkGuard.value.enable = networkGuard.value.enable ? 1 : 0;
      networkGuard.value.reboot = networkGuard.value.reboot ? 1 : 0;
      networkGuard.value.type = networkGuardType.value
        ? networkGuardType.value.id
        : 0;

      // networkGuard.value.ipInternet = ipInternetCode.value ? ipInternetCode.value : null;
      // networkGuard.value.ipIntranet = ipIntranetCode.value ? ipIntranetCode.value : null;

      obj.value = JSON.stringify(networkGuard.value);

    }
    // else if(obj.name == 'daemon_app'){
    //   daemonApp.value.broadcastEnable = daemonApp.value.broadcastEnable ? 1 : 0
    //   daemonApp.value.timeMillisecond = daemonApp.value.timeMillisecond ? daemonApp.value.timeMillisecond * 1000 : 0 ;
    //   daemonApp.value.packageName = daemonAppPackageName.value ? daemonAppPackageName.value.package_name : '';

    //   obj.value =  JSON.stringify(daemonApp.value);
    // }
  });


  const data = {
    id: id.value,
    name: name.value,
    description: description.value,
    settings: settingsArr.value,
    company_id,
  };
  configsStore
    .editConfig(data)
    .then(() => {
      router.push("/configurations");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

onBeforeMount(async () => {
  id.value = route.params.id;
  timeZoneNames = moment.tz.names();

  // await store.dispatch("fetchAllCompanyApps", company_id )
  // .then( async(res) => {
  //   //  //   isLoadingApps.value = false;
  // }).catch( (e) => console.log(e))

  // await store.dispatch("fetchAppsLibrary", company_id )
  // .then( async(res) => {
  //   //  //   isLoadingPreinstalledApps.value = false;
  // }).catch( (e) => console.log(e))

  configsStore
    .getConfigById({ company_id, id: id.value })
    .then(async (res) => {
      name.value = res.data.name;
      description.value = res.data.description;
      if (res && res.data && res.data.settings.length) {
        await res.data.settings.map(async (obj) => {
          if (obj.name == "system_fan") {
            system_fan.value =
              (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "schedule_reboot") {
            schedule_reboot.value =
              (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "show_status_bar") {
            show_status_bar.value =
              (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "gps") {
            gps.value = (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "bluetooth") {
            bluetooth.value =
              (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "mobile_data") {
            mobile_data.value =
              (await parseInt(obj.pivot.value)) == 1 ? true : false;
          } else if (obj.name == "device_name") {
            device_name.value = await obj.pivot.value;
          } else if (obj.name == "schedule_reboot_time") {
            let scheduleRebootTime = obj.pivot.value.split(":");
            schedule_reboot_time.value = await {
              hours: scheduleRebootTime[0],
              minutes: scheduleRebootTime[1],
            };
          } else if (obj.name == "brightness") {
            brightness.value = await parseInt(obj.pivot.value);
          } else if (obj.name == "volume") {
            volume.value = await parseInt(obj.pivot.value);
          } else if (obj.name == "time_zone") {
            time_zone.value = await obj.pivot.value;
          } else if (obj.name == "auto_brightness") {
            let arrAutoBrightnessVal = JSON.parse(obj.pivot.value);
            if (arrAutoBrightnessVal.length) {
              autoBrightnessFields.value = await formatingTimeObject(
                arrAutoBrightnessVal,
              );
            }
            obj.pivot.value = autoBrightnessFields.value;
          } else if (obj.name == "auto_on_off") {
            let arrAutoOnOffVal = JSON.parse(obj.pivot.value);
            if (arrAutoOnOffVal.length) {
              autoOnOffFields.value = await formatingTimeObject(
                arrAutoOnOffVal,
              );
            }
            obj.pivot.value = autoOnOffFields.value;
          } else if (obj.name == "app_mode") {
            obj.pivot.value = JSON.parse(obj.pivot.value);
            appMode.value = obj.pivot.value;
            appMode.value.broadcastEnable = appMode.value.broadcastEnable
              ? true
              : false;
            appMode.value.timeMillisecond = appMode.value.timeMillisecond
              ? appMode.value.timeMillisecond / 1000
              : 0;

            if (
              appMode.value.type == "Multiple" ||
              appMode.value.type == "None"
            ) {
              appMode.value.broadcastEnable = false;
              appMode.value.timeMillisecond = 0;
            }

            if (!appMode.value.apps) {
              if (appMode.value.type == "Single") {
                applicattionModaSelection.value = false;
              } else if (appMode.value.type == "Multiple") {
                applicattionModaSelection.value = true;
              } else if (appMode.value.type == "None") {
                isDisableAppType.value = true;
              }
              appMode.value.apps = [];
            } else {
              if (appMode.value.type == "Single") {
                applicattionModaSelection.value = false;
                appMode.value.apps = appMode.value.apps[0];
              } else if (appMode.value.type == "Multiple") {
                applicattionModaSelection.value = true;
              }
            }
          } else if (obj.name == "pre_installed_apps") {
            obj.pivot.value = JSON.parse(obj.pivot.value);
            if (obj.pivot.value && obj.pivot.value.length) {
              obj.pivot.value.map((pivot) => {
                preinstalledAppsOptions.value.map((app) => {
                  if (pivot.id == app.id) preinstalledApps.value.push(app);
                });
              });
            }
          } else if (obj.name == "network_guard") {
            obj.pivot.value = JSON.parse(obj.pivot.value);
            networkGuard.value = obj.pivot.value;
            networkGuardTypeOptions.value.map((option) => {
              if (option.id == networkGuard.value.type)
                networkGuardType.value = option;
            });
            networkGuard.value.enable = networkGuard.value.enable
              ? true
              : false;
            networkGuard.value.reboot = networkGuard.value.reboot
              ? true
              : false;
          }

          let newObj = {};
          newObj.id = obj.id;
          newObj.name = obj.name;
          newObj.value = obj.pivot.value;
          settingsArr.value.push(newObj);
        });
      }

    })
    .catch(() => {})
    .finally(() => {
      isLoading.value = false;
    });
});

const resetStoreData = () => {
  uiStore.setModalState(false);
  uiStore.setModalData({});
  uiStore.setModalAction(null);
};

onUnmounted(() => {
  resetStoreData();
});

const breadcrumbItems = computed(() => [
  { text: "Configurations", to: "/configurations" },
  { text: name.value || "Loading...", active: true },
]);
</script>

<template>
  <AgentLayout>
    <DBreadcrumb v-if="!isLoading" :items="breadcrumbItems" />

    <PageHeader
      v-if="!isLoading"
      title="Configurations Settings"
      subtitle="Manage device settings and parameters to optimize performance and behavior."
    />
    <div class="settings-card card">
      <!-- Nav tabs -->
      <div v-if="isLoading" class="config-skeleton" aria-busy="true" aria-live="polite">
        <span class="visually-hidden">Loading…</span>
        <div class="config-skeleton__tabs">
          <div class="skel-block skel-tab"></div>
          <div class="skel-block skel-tab"></div>
          <div class="skel-block skel-tab"></div>
        </div>
        <div class="config-skeleton__row">
          <div class="skel-block skel-checkbox"></div>
          <div class="skel-block skel-checkbox"></div>
          <div class="skel-block skel-checkbox"></div>
          <div class="skel-block skel-checkbox"></div>
        </div>
        <div class="skel-block skel-divider"></div>
        <div class="config-skeleton__row">
          <div class="skel-block skel-input"></div>
          <div class="skel-block skel-input"></div>
        </div>
        <div class="skel-block skel-divider"></div>
        <div class="config-skeleton__row">
          <div class="skel-block skel-input"></div>
          <div class="skel-block skel-input"></div>
        </div>
      </div>
      <div v-else>
        <ul class="mb-40 configurations-tabs" id="myTab" role="tablist">
          <div class="tab-item" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'" type="button">General</div>
          <div class="tab-item" :class="{ active: activeTab === 'screen' }" @click="activeTab = 'screen'" type="button">Power Saving</div>
          <div class="tab-item" :class="{ active: activeTab === 'network' }" @click="activeTab = 'network'" type="button">Network Guard</div>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
          <div
            v-show="activeTab === 'general'" role="tabpanel" tabindex="0"
          >
            <div class="w-full flex mb-40 checkbox-group">
              <div class="w-1/4 flex p-0">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    id="system_fan"
                    value="system_fan"
                    v-model="system_fan"
                  />
                  <label for="system_fan">System Fan</label>
                </div>
              </div>
              <div class="w-1/4 flex p-0">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    id="schedule_reboot"
                    value="schedule_reboot"
                    v-model="schedule_reboot"
                  />
                  <label for="schedule_reboot">Schedule Reboot</label>
                </div>
              </div>
              <div class="w-1/4 flex p-0">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    id="show_status_bar"
                    value="show_status_bar"
                    v-model="show_status_bar"
                  />
                  <label for="show_status_bar">Hide Status Bar</label>
                </div>
              </div>
              <div class="w-1/4 flex p-0">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    id="bluetooth"
                    value="bluetooth"
                    v-model="bluetooth"
                  />
                  <label for="bluetooth">Bluetooth</label>
                </div>
              </div>
            </div>

            <!-- <div class="w-full flex mb-3"> -->

            <!-- <div class="w-1/3 flex p-0">
                <label class="form-check-label text w-140">GPS</label>

                <div class="flex">
                  <div class="button r radio-with-text  flex">
                    <input v-model="gps" type="checkbox" class="checkbox" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                </div>

              </div> -->

            <!-- <div class="line-between"></div> -->

            <!-- <div class="w-1/3 flex p-0">
                <label class="form-check-label text w-140">Bluetooth</label>

                <div class="flex">
                  <div class="button r radio-with-text  flex">
                    <input v-model="bluetooth" type="checkbox" class="checkbox" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                </div>

              </div> -->

            <!-- <div class="line-between"></div> -->

            <!-- <div class="w-1/3 flex p-0">
                <label class="form-check-label text w-140" >Mobile Data</label>
                <div class=" flex">
                  <div class="button r radio-with-text  flex">
                    <input v-model="mobile_data" type="checkbox" class="checkbox" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                </div>

              </div> -->

            <!-- </div>  -->

            <div class="setting-seperator text-center"></div>

            <div class="flex w-full padding-none mb-0">
              <div class="w-1/2">
                <div
                  class="flex items-center justify-between w-416 config_settings_time"
                >
                  <p class="mb-0 reboot-time form-check-label">Reboot Time</p>
                  <div class="timepacker">
                    <VueDatePicker
                      v-model="schedule_reboot_time"
                      time-picker
                      auto-apply
                      format="HH:mm"
                      :clearable="true"
                    >
                      <template #input-icon>
                        <i class="input-slot-image">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              :fill="
                                schedule_reboot_time ? '#2D8425' : '#787878'
                              "
                              d="M8.75 0C3.9375 0 0 3.9375 0 8.75C0 13.5625 3.9375 17.5 8.75 17.5C13.5625 17.5 17.5 13.5625 17.5 8.75C17.5 3.9375 13.5625 0 8.75 0ZM11.8125 10.5C11.55 10.9375 11.025 11.025 10.5875 10.85L8.3125 9.5375C8.05 9.3625 7.875 9.1 7.875 8.75V4.375C7.875 3.85 8.225 3.5 8.75 3.5C9.275 3.5 9.625 3.85 9.625 4.375V8.225L11.4625 9.275C11.9 9.5375 11.9875 10.0625 11.8125 10.5Z"
                            />
                          </svg>
                        </i>
                      </template>
                      <template #clear-icon="{ clear }">
                        <button
                          type="button"
                          class="reboot-clear-btn"
                          aria-label="Clear reboot time"
                          @click.stop="clear"
                        >
                          <i class="bi bi-x-lg"></i>
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                </div>
              </div>

              <div class="w-1/2 mb-3">
                <FloatLabel class="w-full md:w-14rem">
                  <PDropdown
                    v-model="time_zone"
                    inputId="timeZone"
                    :options="timeZoneNames"
                    :disabled="!timeZoneNames.length || !!time_zone"
                    :loading="!timeZoneNames.length"
                    class="w-full"
                    variant="filled"
                    filter
                    filterPlaceholder="Search time zone"
                  />
                  <label for="timeZone">Time Zone</label>
                </FloatLabel>
              </div>
            </div>

            <div class="setting-seperator text-center"></div>

            <div class="flex w-full padding-none">
              <div class="w-1/2">
                <div
                  class="flex items-center justify-center mb-3 w-416"
                >
                  <label
                    for="brightnessRange"
                    class="form-label brightness form-check-label"
                    >Brightness</label
                  >
                  <div class="ml-auto percentage-box">
                    <p class="percentege">{{ brightness }}%</p>
                  </div>
                </div>
                <input
                  type="range"
                  class="form-range w-416"
                  id="brightnessRange"
                  v-model="brightness"
                />
              </div>

              <div class="w-1/2">
                <div
                  class="flex items-center justify-center mb-3 w-416"
                >
                  <label for="volumeRange" class="volume form-check-label"
                    >Volume</label
                  >
                  <div class="ml-auto percentage-box">
                    <p class="percentege">{{ volume }}%</p>
                  </div>
                </div>
                <input
                  type="range"
                  class="form-range w-416"
                  id="volumeRange"
                  v-model="volume"
                />
              </div>
            </div>
          </div>
          <div
            v-show="activeTab === 'screen'" role="tabpanel" tabindex="0"
          >
            <div class="mb-40">
              <label class="form-label mb-20 form-check-label text"
                >Auto Brightness Times</label
              >

              <div v-if="autoBrightnessFields && autoBrightnessFields.length">
                <div
                  class="flex mb-2"
                  v-for="(field, index) in autoBrightnessFields"
                  :key="index"
                >
                  <div
                    class="flex items-center justify-between config_settings_time"
                  >
                    <div class="flex">
                      <p class="time-input-text">From</p>
                      <div class="timepacker">
                        <VueDatePicker
                          v-model="field.start"
                          time-picker
                          auto-apply
                          format="HH:mm"
                          :clearable="false"
                          id="auto-brightness-time"
                        >
                          <template #input-icon>
                            <i class="input-slot-image">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  :fill="field.start ? '#2D8425' : '#787878'"
                                  d="M8.75 0C3.9375 0 0 3.9375 0 8.75C0 13.5625 3.9375 17.5 8.75 17.5C13.5625 17.5 17.5 13.5625 17.5 8.75C17.5 3.9375 13.5625 0 8.75 0ZM11.8125 10.5C11.55 10.9375 11.025 11.025 10.5875 10.85L8.3125 9.5375C8.05 9.3625 7.875 9.1 7.875 8.75V4.375C7.875 3.85 8.225 3.5 8.75 3.5C9.275 3.5 9.625 3.85 9.625 4.375V8.225L11.4625 9.275C11.9 9.5375 11.9875 10.0625 11.8125 10.5Z"
                                />
                              </svg>
                            </i>
                          </template>
                        </VueDatePicker>
                      </div>
                    </div>

                    <div class="flex ml-20 mr-30">
                      <p class="time-input-text">To</p>
                      <div class="timepacker">
                        <VueDatePicker
                          v-model="field.end"
                          time-picker
                          auto-apply
                          format="HH:mm"
                          :clearable="false"
                          id="auto-brightness-time"
                        >
                          <template #input-icon>
                            <i class="input-slot-image">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  :fill="field.end ? '#2D8425' : '#787878'"
                                  d="M8.75 0C3.9375 0 0 3.9375 0 8.75C0 13.5625 3.9375 17.5 8.75 17.5C13.5625 17.5 17.5 13.5625 17.5 8.75C17.5 3.9375 13.5625 0 8.75 0ZM11.8125 10.5C11.55 10.9375 11.025 11.025 10.5875 10.85L8.3125 9.5375C8.05 9.3625 7.875 9.1 7.875 8.75V4.375C7.875 3.85 8.225 3.5 8.75 3.5C9.275 3.5 9.625 3.85 9.625 4.375V8.225L11.4625 9.275C11.9 9.5375 11.9875 10.0625 11.8125 10.5Z"
                                />
                              </svg>
                            </i>
                          </template>
                        </VueDatePicker>
                      </div>
                    </div>

                    <div class="ml-20">
                      <div class="w-full flex justify-center">
                        <p class="time-input-text">Brightness</p>
                        <div
                          class="w-full flex items-center justify-center"
                        >
                          <div class="w-2/3">
                            <input
                              type="range"
                              class="form-range"
                              v-model="field.value"
                            />
                          </div>

                          <div class="ml-auto percentage-box ml-20 w-1/3">
                            <p class="percentege">{{ field.value }} %</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <span
                      @click="removeAutoBrightnessField(index)"
                      class="ml-40 cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          fill="#F46A6A"
                          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                        />
                      </svg>
                    </span>
                  </div>
                </div>

                <button
                  @click="addAutoBrightnessField"
                  type="button"
                  class="btn btn-outline-success m-5 font-14 mass-action-grid-btn float-right"
                >
                  Add New
                </button>
              </div>

              <div v-else class="flex justify-center">
                <div class="no-times-card mt-40">
                  <p
                    class="second-success-card-email-message mt-15 text-center"
                  >
                    No times exist for auto brightness
                  </p>
                  <div class="text-center">
                    <button
                      @click="addAutoBrightnessField"
                      type="button"
                      class="btn btn-outline-success m-5 font-14 mass-action-grid-btn"
                    >
                      Add New
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="setting-seperator-2 text-center"></div>

            <div class="mb-40">
              <!-- <label class="form-label mb-20 form-check-label text">Auto On / Off Times</label> -->

              <div v-if="autoOnOffFields && autoOnOffFields.length">
                <div
                  class="flex mb-2"
                  v-for="(field, index) in autoOnOffFields"
                  :key="index"
                >
                  <!-- <div class="items-center justify-center flex mr-30" > -->
                  <!-- <p class="time-input-text">Power</p>
                      
                      <div class="form-check form-switch">
                        <input v-model="field.value" class="form-check-input" type="checkbox" role="switch" :id="'modeOnOff'+index"/>
                      </div> -->

                  <!-- <div class="mt-24 flex">
                        <label class="form-check-label text w-140"> Enable </label>
                        <div class="button r radio-with-text  flex">
                          <input v-model="field.value" type="checkbox" class="checkbox" />
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div> -->

                  <!-- </div> -->

                  <div
                    class="flex items-center justify-between config_settings_time"
                  >
                    <div class="flex mr-20">
                      <label class="text mr-20" :for="'modeOnOff' + index"
                        >Auto On / Off Times</label
                      >
                      <div class="flex">
                        <div class="button r radio-with-text flex">
                          <input
                            v-model="field.value"
                            type="checkbox"
                            class="checkbox"
                            :id="'modeOnOff' + index"
                          />
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>

                    <div class="flex">
                      <p class="time-input-text">Start Up</p>
                      <div class="timepacker">
                        <VueDatePicker
                          :disabled="field.value ? false : true"
                          v-model="field.start"
                          time-picker
                          auto-apply
                          format="HH:mm"
                          :clearable="false"
                          id="auto-brightness-time"
                        >
                          <template #input-icon>
                            <i
                              class="input-slot-image"
                              :class="{
                                'disabled-style': field.value ? false : true,
                              }"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  :fill="field.start ? '#2D8425' : '#787878'"
                                  d="M8.75 0C3.9375 0 0 3.9375 0 8.75C0 13.5625 3.9375 17.5 8.75 17.5C13.5625 17.5 17.5 13.5625 17.5 8.75C17.5 3.9375 13.5625 0 8.75 0ZM11.8125 10.5C11.55 10.9375 11.025 11.025 10.5875 10.85L8.3125 9.5375C8.05 9.3625 7.875 9.1 7.875 8.75V4.375C7.875 3.85 8.225 3.5 8.75 3.5C9.275 3.5 9.625 3.85 9.625 4.375V8.225L11.4625 9.275C11.9 9.5375 11.9875 10.0625 11.8125 10.5Z"
                                />
                              </svg>
                            </i>
                          </template>
                        </VueDatePicker>
                      </div>
                    </div>

                    <div class="flex ml-20 mr-30">
                      <p class="time-input-text">Shut Down</p>
                      <div class="timepacker">
                        <VueDatePicker
                          :disabled="field.value ? false : true"
                          v-model="field.end"
                          time-picker
                          auto-apply
                          format="HH:mm"
                          :clearable="false"
                          id="auto-brightness-time"
                        >
                          <template #input-icon>
                            <i
                              class="input-slot-image"
                              :class="{
                                'disabled-style': field.value ? false : true,
                              }"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  :fill="field.end ? '#2D8425' : '#787878'"
                                  d="M8.75 0C3.9375 0 0 3.9375 0 8.75C0 13.5625 3.9375 17.5 8.75 17.5C13.5625 17.5 17.5 13.5625 17.5 8.75C17.5 3.9375 13.5625 0 8.75 0ZM11.8125 10.5C11.55 10.9375 11.025 11.025 10.5875 10.85L8.3125 9.5375C8.05 9.3625 7.875 9.1 7.875 8.75V4.375C7.875 3.85 8.225 3.5 8.75 3.5C9.275 3.5 9.625 3.85 9.625 4.375V8.225L11.4625 9.275C11.9 9.5375 11.9875 10.0625 11.8125 10.5Z"
                                />
                              </svg>
                            </i>
                          </template>
                        </VueDatePicker>
                      </div>
                    </div>

                    <!-- <span @click="removeAutoOnOffField(index)" class="ml-40 cursor-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 22" fill="none" >
                        <path fill="#F46A6A"
                          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                        />
                      </svg>
                    </span> -->
                  </div>
                </div>

                <!-- <button  @click="addAutoOnOffField" type="button" class="btn btn-outline-success m-5 font-14 mass-action-grid-btn  float-right">
                  Add New
                </button> -->
              </div>

              <div v-else class="flex justify-center">
                <div class="no-times-card mt-40">
                  <p
                    class="second-success-card-email-message mt-15 text-center"
                  >
                    No times exist for auto on / off
                  </p>
                  <div class="text-center">
                    <button
                      @click="addAutoOnOffField"
                      type="button"
                      class="btn btn-outline-success m-5 font-14 mass-action-grid-btn"
                    >
                      Add New
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="setting-seperator-2 text-center"></div> -->
          </div>

          <div
            v-show="activeTab === 'app-mode'" role="tabpanel" tabindex="0"
          >
            <div class="w-full padding-none flex">
              <div class="w-1/2 padding-none">
                <div class="relative mb-3">
                  <span v-if="appMode.type" class="multiselect-title-span"
                    >Type</span
                  >
                  <VMultiselect
                    @select="changeTypeVal"
                    v-model="appMode.type"
                    :options="appModeTypeOptions"
                    :loading="!appModeTypeOptions.length"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="Type"
                  />
                </div>

                <div class="relative">
                  <span
                    v-if="
                      (appMode.type == 'Multiple' && appMode.apps.length) ||
                      (appMode.type == 'Single' && appMode.apps)
                    "
                    class="multiselect-title-span"
                    >Applications</span
                  >
                  <VMultiselect
                    :class="{
                      'multiselect-options':
                        appMode.type == 'Multiple' && appMode.apps.length,
                    }"
                    v-model="appMode.apps"
                    :options="appsOptions"
                    :disabled="
                      !appsOptions.length ||
                      isDisableAppType ||
                      appMode.type == 'None'
                    "
                    :multiple="applicattionModaSelection"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="Applications"
                    trackBy="package_name"
                    label="name"
                    :loading="isLoadingApps"
                  />
                </div>
              </div>

              <div v-if="appMode.type == 'Single'" class="w-1/2 padding-none">
                <div class="w-full flex p-0 mb-5">
                  <label class="form-check-label text w-140"
                    >Enable broadcast</label
                  >
                  <div class="flex">
                    <div class="button r radio-with-text flex">
                      <input
                        v-model="appMode.broadcastEnable"
                        type="checkbox"
                        class="checkbox"
                      />
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

                <div class="w-full flex p-0">
                  <div class="form-floating flex">
                    <input
                      v-model="appMode.timeMillisecond"
                      min="0"
                      type="number"
                      class="w-335 form-control input-remove-right-border-radius"
                      id="appModeTime"
                      placeholder="Time"
                    />
                    <label for="appModeTime">Time</label>
                    <div class="input-border-wrapper">
                      <div class="input-border"></div>
                    </div>
                    <div class="minutes-label">
                      <div class="minutes">Seconds</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="activeTab === 'preinstalled-apps'" role="tabpanel" tabindex="0"
          >
            <div class="relative">
              <span
                v-if="preinstalledApps.length"
                class="multiselect-title-span"
                >Applications (Optional)</span
              >
              <VMultiselect
                :class="{ 'multiselect-options': preinstalledApps.length }"
                v-model="preinstalledApps"
                :options="preinstalledAppsOptions"
                :disabled="!preinstalledAppsOptions.length"
                :multiple="true"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Applications (Optional)"
                trackBy="id"
                label="name"
                :loading="isLoadingPreinstalledApps"
              />
            </div>
            <span class="hint-input"
              ><b>Note:</b> You can't delete the selected applications from apps
              library
            </span>
          </div>

          <div
            v-show="activeTab === 'network'" role="tabpanel" tabindex="0"
          >
            <div class="mb-40">
              <div
                class="w-full flex mb-3 padding-none justify-center items-center"
              >
                <div class="w-1/2 p-0">
                  <div class="flex justify-start items-center">
                    <!-- <label class="form-check-label text w-140" for="enable"> Enable </label>
                    <div class="flex">
                      <div class="button r radio-with-text  flex">
                        <input v-model="networkGuard.enable" type="checkbox" class="checkbox" id="enable" />
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div> -->

                    <div class="w-1/4 flex p-0">
                      <div class="checkbox-item">
                        <label for="enable">Enable</label>

                        <input
                          type="checkbox"
                          id="enable"
                          value="enable"
                          v-model="networkGuard.enable"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="line-between"></div> -->

                <div class="w-1/2 p-0">
                  <div class="flex justify-start items-center">
                    <div class="w-1/4 flex p-0">
                      <div class="checkbox-item">
                        <label for="reboot">Reboot</label>
                        <input
                          type="checkbox"
                          id="reboot"
                          value="reboot"
                          v-model="networkGuard.reboot"
                        />
                      </div>
                    </div>

                    <!-- <label class="form-check-label text w-140" for="reboot">Reboot</label>
                    <div class="flex">
                      <div class="button r radio-with-text  flex">
                        <input v-model="networkGuard.reboot" type="checkbox" class="checkbox" id="reboot" />
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div> -->
                    <div>
                      <button class="info-popover" title="Whether to restart after repairing network failure Reboot, if the repair fails, restart the system to re-diagnose: if it fails to restart several times in a row, it will enter the dormant state: if the network changes are monitored, it will resume the guardian and start detection, and continue to sleep if the detection fails.">
                        <i class="bi bi-info-circle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-full flex padding-none mb-3">
                <div class="w-1/2 padding-none flex">
                  <!-- <div class="relative">
                    <span
                      v-if="networkGuard.type >= 0 && networkGuardType"
                      class="multiselect-title-span"
                      >Type</span
                    >
                    <VMultiselect
                      @select="changeTypeVal"
                      v-model="networkGuardType"
                      :options="networkGuardTypeOptions"
                      :loading="!networkGuardTypeOptions.length"
                      :searchable="true"
                      :close-on-select="true"
                      trackBy="id"
                      label="name"
                      :show-labels="false"
                      placeholder="Type"
                    />
                  </div> -->

                  <FloatLabel class="w-full md:w-14rem mb-3">
                    <PDropdown
                      v-model="networkGuardType"
                      inputId="networkGuardType"
                      :options="networkGuardTypeOptions"
                      optionLabel="name"
                      optionValue="id"
                      class="w-full"
                      @change="changeTypeVal"
                      variant="filled"
                      filter
                      filterPlaceholder="Search type"
                    >
                    </PDropdown>
                    <label for="networkGuardType">Type</label>
                  </FloatLabel>

                  <button class="info-popover" title="Selecting Automatic will try to repair all network types, it is recommended to select the current network environment.">
                    <i class="bi bi-info-circle"></i>
                  </button>
                </div>

                <div class="w-1/2 padding-none">
                  <div class="flex">
                    <div class="form-floating flex">
                      <input
                        :class="{ 'is-invalid': isInvalidNetworkGuardTime }"
                        @input="changeNetworkGuardTime"
                        v-model="networkGuard.time"
                        min="3"
                        max="15"
                        type="number"
                        class="w-335 form-control input-remove-right-border-radius"
                        id="networkGuardTime"
                        placeholder="Time"
                      />
                      <label for="networkGuardTime">Time</label>

                      <div class="input-border-wrapper">
                        <div class="input-border"></div>
                      </div>
                      <div class="minutes-label">
                        <div class="minutes">Minutes</div>
                      </div>
                    </div>

                    <button class="info-popover" title="Interval time for re-diagnosis after diagnosis and repair, no less than 3 minutes; it is not recommended to set too short a time to cause too frequent detection.">
                      <i class="bi bi-info-circle"></i>
                    </button>
                  </div>

                  <div v-if="isInvalidNetworkGuardTime" class="invalid-message">
                    Enter number between 3 and 15
                  </div>
                </div>
              </div>

              <div class="w-full flex padding-none mb-3">
                <div class="w-1/2 padding-none flex">
                  <div class="form-floating mb-3">
                    <input
                      type="text"
                      v-model="networkGuard.ipInternet"
                      class="form-control"
                      id="ipInternet"
                      placeholder=""
                    />
                    <label for="ipInternet">IP Internet</label>
                  </div>

                  <!-- <div class="form-floating flex ip-input-container">
                    <input type="text" maxlength="3" v-model="ipInternet[0]" @keyup="moveToNext($event, 'ip-internet-input', 0)" class="form-control ip-input-box ip-internet-input
                     border-right none-border-top-right-raduis none-border-bottom-right-raduis" id="ipInternetGroup" placeholder=""/>
                    <span v-if="ipInternetCode ">.</span>
                    <input type="text" maxlength="3" v-model="ipInternet[1]" @keyup="moveToNext($event, 'ip-internet-input', 1)" class="form-control ip-input-box ip-internet-input 
                    border-right none-border-top-right-raduis none-border-bottom-right-raduis" placeholder=""/>
                    <span v-if="ipInternetCode">.</span>
                    <input type="text" maxlength="3" v-model="ipInternet[2]" @keyup="moveToNext($event, 'ip-internet-input', 2)" class="form-control ip-input-box ip-internet-input 
                    border-right none-border-top-right-raduis none-border-bottom-right-raduis" placeholder=""/>
                    <span v-if="ipInternetCode">.</span>
                    <input type="text" maxlength="3" v-model="ipInternet[3]" @keyup="moveToNext($event, 'ip-internet-input', 3)" class="form-control ip-input-box ip-internet-input" placeholder=""/>
                    <label for="ipInternetGroup">IP Internet</label>
                  </div> -->

                  <button class="info-popover" title="Used to detect whether the external network is communicating.">
                    <i class="bi bi-info-circle"></i>
                  </button>
                </div>

                <div class="w-1/2 padding-none flex">
                  <div class="form-floating mb-3">
                    <input
                      type="text"
                      v-model="networkGuard.ipIntranet"
                      class="form-control"
                      id="ipIntranet"
                      placeholder=""
                    />
                    <label for="ipIntranet">IP Intranet</label>
                  </div>

                  <!-- <div class="form-floating flex ip-input-container">
                    <input type="text" maxlength="3" v-model="ipIntranet[0]" @keyup="moveToNext($event, 'ip-intranet-input', 0)" class="form-control ip-input-box ip-intranet-input
                    border-right none-border-top-right-raduis none-border-bottom-right-raduis" id="ipInternetGroup" placeholder=""/>
                    <span v-if="ipIntranetCode ">.</span>
                    <input type="text" maxlength="3" v-model="ipIntranet[1]" @keyup="moveToNext($event, 'ip-intranet-input', 1)" class="form-control ip-input-box ip-intranet-input
                    border-right none-border-top-right-raduis none-border-bottom-right-raduis none-border-top-left-raduis none-border-bottom-left-raduis" placeholder=""/>
                    <span v-if="ipIntranetCode">.</span>
                    <input type="text" maxlength="3" v-model="ipIntranet[2]" @keyup="moveToNext($event, 'ip-intranet-input', 2)" class="form-control ip-input-box ip-intranet-input
                    border-right none-border-top-right-raduis none-border-bottom-right-raduis none-border-top-left-raduis none-border-bottom-left-raduis" placeholder=""/>
                    <span v-if="ipIntranetCode">.</span>
                    <input type="text" maxlength="3" v-model="ipIntranet[3]" @keyup="moveToNext($event, 'ip-intranet-input', 3)" class="form-control ip-input-box ip-intranet-input" placeholder=""/>
                    <label for="ipIntranetGroup">IP Intranet</label>
                  </div> -->

                  <button class="info-popover" title="The gateway is automatically used for initialization, and it is not necessary to fill in if the intranet is not used.">
                    <i class="bi bi-info-circle"></i>
                  </button>
                </div>
              </div>

              <div class="w-full flex padding-none">
                <div class="w-1/2 padding-none">
                  <div class="form-floating mb-3">
                    <input
                      type="text"
                      v-model="networkGuard.logPath"
                      class="form-control"
                      id="logPath"
                      placeholder=""
                    />
                    <label for="logPath">Log Path</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="tab-pane" id="daemon-app" role="tabpanel" aria-labelledby="daemon-app-tab" tabindex="0">

            <div class="mb-40">
              

              <div class="w-full flex  padding-none">

                <div class="w-1/2 padding-none">

                  <div class="relative">
                    <span v-if="daemonAppPackageName" class="multiselect-title-span">Package Name</span>
                    <VMultiselect  v-model="daemonAppPackageName" :options="appsOptions" :disabled="!appsOptions.length" 
                    :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Package Name"
                    trackBy="package_name" label="name" :loading="isLoadingApps"
                    />
                  </div>

                </div>

            

              </div>

            </div>

          </div> -->
        </div>

        <div class="flex mt-20 float-right right-bottom-btn">
          <button
            :disabled="isSubmitted || isInvalidNetworkGuardTime"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Submit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </AgentLayout>
</template>
<style scoped>
ul {
  padding-left: 0px !important;
}

/* ── Loading skeleton ──────────────────────────────────────── */
.config-skeleton {
  padding: 8px 0 24px;
}

.config-skeleton__tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 28px;
}

.config-skeleton__row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.config-skeleton__row > * {
  flex: 1;
}

.skel-block {
  background: linear-gradient(90deg, #eef2f7 25%, #e0e6ee 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: config-skeleton-shimmer 1.5s infinite;
  border-radius: 8px;
}

.skel-tab {
  width: 110px;
  height: 22px;
  flex: 0 0 auto;
}

.skel-checkbox {
  height: 22px;
}

.skel-input {
  height: 48px;
}

.skel-divider {
  height: 1px;
  margin: 24px 0;
  border-radius: 0;
}

@keyframes config-skeleton-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

[data-theme="dark"] .skel-block {
  background: linear-gradient(
    90deg,
    #1e2a3e 25%,
    #28364e 50%,
    #1e2a3e 75%
  );
  background-size: 200% 100%;
}

/* ── Dark mode: page-specific classes ─────────────────────── */
[data-theme="dark"] :deep(.checkbox-item label) {
  color: #e8edf5;
}

[data-theme="dark"] :deep(.percentage-box) {
  background: #28364e;
  color: #e8edf5;
}

[data-theme="dark"] :deep(.percentege) {
  color: #e8edf5;
}

[data-theme="dark"] :deep(.minutes-label) {
  background-color: #28364e;
  color: #9aadc4;
}

[data-theme="dark"] :deep(.minutes) {
  border-left-color: #3d5070;
}

[data-theme="dark"] :deep(.no-times-card) {
  background: #1e2a3e;
  border: 1px solid #2d3f5a;
}

[data-theme="dark"] :deep(.second-success-card-email-message) {
  color: #9aadc4;
}

[data-theme="dark"] :deep(.info-popover),
[data-theme="dark"] :deep(.info-popover:hover) {
  color: #9aadc4 !important;
}

[data-theme="dark"] :deep(.hint-input) {
  color: #9aadc4;
}

[data-theme="dark"] :deep(.reboot-time),
[data-theme="dark"] :deep(.brightness),
[data-theme="dark"] :deep(.volume),
[data-theme="dark"] :deep(.time-input-text),
[data-theme="dark"] :deep(.text),
[data-theme="dark"] :deep(.form-check-label) {
  color: #e8edf5;
}

[data-theme="dark"] :deep(.input-slot-image.disabled-style) {
  opacity: 0.45;
}

/* ── Reboot Time clear icon: align left ──────────────────── */
.config_settings_time :deep(.dp__input_wrap) {
  position: relative;
}

.config_settings_time :deep(.dp__clear_icon),
.config_settings_time :deep(.dp--clear-btn) {
  left: 8px;
  right: auto !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.config_settings_time :deep(.dp__input) {
  padding-left: 40px;
  padding-right: 36px;
}

.config_settings_time :deep(.dp__input_icon) {
  right: 12px !important;
  left: auto !important;
}

.reboot-clear-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.reboot-clear-btn i {
  font-size: 12px;
  line-height: 1;
}

.reboot-clear-btn:hover {
  background: rgba(244, 106, 106, 0.12);
  color: #dc2626;
}

[data-theme="dark"] .reboot-clear-btn {
  color: #6480a0;
}

[data-theme="dark"] .reboot-clear-btn:hover {
  background: rgba(248, 113, 113, 0.18);
  color: #f87171;
}

/* ── Brightness / Volume slider + value chip ────────────── */
:deep(.form-range) {
  width: 100%;
  height: 6px;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
}

:deep(.form-range::-webkit-slider-runnable-track) {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
}

:deep(.form-range::-moz-range-track) {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
}

:deep(.form-range::-webkit-slider-thumb) {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4e7fff;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.18);
  margin-top: -5px;
  cursor: pointer;
  transition: transform 0.15s ease;
}

:deep(.form-range::-moz-range-thumb) {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4e7fff;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.18);
  cursor: pointer;
  transition: transform 0.15s ease;
}

:deep(.form-range:hover::-webkit-slider-thumb),
:deep(.form-range:focus::-webkit-slider-thumb) {
  transform: scale(1.12);
}

:deep(.form-range:hover::-moz-range-thumb),
:deep(.form-range:focus::-moz-range-thumb) {
  transform: scale(1.12);
}

:deep(.percentage-box) {
  width: auto;
  min-width: 56px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:deep(.percentege) {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--primary-hover);
  line-height: 1;
}

[data-theme="dark"] :deep(.form-range::-webkit-slider-runnable-track),
[data-theme="dark"] :deep(.form-range::-moz-range-track) {
  background: #2d3f5a;
}

[data-theme="dark"] :deep(.form-range::-webkit-slider-thumb),
[data-theme="dark"] :deep(.form-range::-moz-range-thumb) {
  background: #6b96ff;
  border-color: #1e2a3e;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
}

[data-theme="dark"] :deep(.percentage-box) {
  background: #1a2d52;
  border-color: #3d5070;
}

[data-theme="dark"] :deep(.percentege) {
  color: #a8c4ff;
}

[data-theme="dark"] :deep(.form-range) {
  accent-color: #4e7fff;
}

[data-theme="dark"] :deep(.invalid-message) {
  color: #f87171;
}

[data-theme="dark"] :deep(.disabled-span-multiselect),
[data-theme="dark"] :deep(.multiselect-title-span) {
  background: #1e2a3e;
  color: #6480a0;
}
</style>
